import PropTypes from 'prop-types';
import React from 'react';
import { Popover } from 'react-bootstrap';
import { linkedAdjustmentsShape } from '../../../../../common/components/proptypes/commonProptypes';
import LinkedAdjustmentEditor from '../../../../linking/common/LinkedAdjustmentsEditor/LinkedAdjustmentsEditor';

import './LinkedAdjustmentEditPopover.scss';

const LinkedAdjustmentEditPopover = React.forwardRef(
  (
    {
      adjustmentLinks,
      projectId,
      sourceAdjustment,
      adjustmentOptions,
      targetDocumentOptions,
      selectedLinkedAdjustments,
      setFieldValue,
      ...props
    },
    ref
  ) => {
    return (
      <Popover
        id="popover-linked-adjustments-edit"
        ref={ref}
        data-testid="popover-linked-adjustments-edit"
        {...props}
      >
        <Popover.Content className="popup-menu-edit">
          <LinkedAdjustmentEditor
            sourceAdjustment={{
              value: sourceAdjustment,
            }}
            adjustmentOptions={adjustmentOptions}
            targetDocumentOptions={targetDocumentOptions}
            selectedLinkedAdjustments={selectedLinkedAdjustments.filter(
              (s) => s.sourceAdjustment === sourceAdjustment
            )}
            setFieldValue={setFieldValue}
            adjustmentLinks={adjustmentLinks}
            projectId={projectId}
          />
        </Popover.Content>
      </Popover>
    );
  }
);

LinkedAdjustmentEditPopover.propTypes = {
  adjustmentLinks: PropTypes.arrayOf(linkedAdjustmentsShape),
  projectId: PropTypes.string.isRequired,
};

LinkedAdjustmentEditPopover.defaultProps = {
  adjustmentLinks: [],
};

export default LinkedAdjustmentEditPopover;
